import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogTitle,
} from '@ovComponents/2-component/dialog/dialog';
import { Box, Button, IconButton, Tooltip, useTheme } from 'hephaestus/web';
import { FilterList as Filter } from 'hephaestus/webIcons';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export const FilterModal = ({
  children,
  filterExists,
  sx = {},
  title,
  onConfirm,
  onClose,
  onClearAll,
  disabled,
  testIds,
}: {
  children: any;
  filterExists?: boolean;
  sx?: any;
  title?: string;
  onConfirm?: () => void;
  onClose?: () => void;
  onClearAll?: () => void;
  disabled?: boolean;
  testIds?: {
    dialogOpenButton?: string;
    dialogSubmitButton?: string;
    dialogCloseButton?: string;
  };
}) => {
  const { t } = useTranslation(['components', 'shared']);
  const [open, setOpen] = useState(false);
  const theme = useTheme();

  const onCloseClick = () => {
    setOpen(false);
    if (onClose) {
      onClose();
    }
  };
  const onConfirmClick = () => {
    setOpen(false);
    if (onConfirm) {
      onConfirm();
    }
  };
  const onClearAllClick = () => {
    setOpen(false);
    if (onClearAll) {
      onClearAll();
    }
  };

  return (
    <>
      <Box
        sx={[
          {
            position: 'relative',
          },
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
      >
        <Tooltip title={t('filter')}>
          <IconButton
            onClick={() => setOpen(true)}
            data-testid={testIds?.dialogOpenButton}
            aria-label={t('filter')}
          >
            <Filter fontSize='inherit' />
          </IconButton>
        </Tooltip>
        {filterExists && (
          <Box
            sx={{
              position: 'absolute',
              top: '8px',
              right: '8px',
              height: '8px',
              width: '8px',
              borderRadius: '50%',
              backgroundColor: theme.color.negative,
            }}
          />
        )}
      </Box>
      <Dialog open={open} onClose={onCloseClick} fullWidth maxWidth='xs'>
        <DialogTitle
          testIds={{ dialogCloseButton: testIds?.dialogCloseButton }}
          onClose={onCloseClick}
        >
          {title ?? t('filter')}
        </DialogTitle>
        <DialogContent>{children}</DialogContent>
        <DialogFooter>
          {!!onClearAll && (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
              }}
            >
              <Button
                variant='contained'
                onClick={onClearAllClick}
                sx={{ mr: 1 }}
                disabled={!filterExists}
                color='secondary'
              >
                {t('shared:clearAll')}
              </Button>
            </Box>
          )}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            <Button
              disabled={disabled}
              onClick={onConfirmClick}
              data-testid={testIds?.dialogSubmitButton}
            >
              {t('shared:done')}
            </Button>
          </Box>
        </DialogFooter>
      </Dialog>
    </>
  );
};
